import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse"; /// Link
import { NavMenuToggle } from "./NavHader";

const AdminSidebar = ({ state, setState, menuListData, sidebarLoading }) => {
  

  const loginDetails = JSON.parse(localStorage.getItem("login_Details"));
  const { name, email, user } = loginDetails || {};
  const token = localStorage.getItem("access_token_admin");
  const userLevel = user?.user_level;

  const location = useLocation();
  let currentPath = location.pathname;
  let path = currentPath.split("/");
  path = path[path.length - 1];

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };



const handleSubmenuActive = (status, parentTitle) => {
  const newValue = state.activeSubmenu === status ? "" : status;

  localStorage.setItem("activeSubmenu", newValue);

  setState({
    activeSubmenu: newValue,
    active: parentTitle, // ✅ THIS LINE FIXES EVERYTHING
  });
};

  // ✅ OPTIONAL (if you also want parent menu persist)
  // const handleMenuActive = (status) => {
  //   setState({
  //     active: state.active === status ? "" : status
  //   });
  //   localStorage.setItem("activeMenu", state.active === status ? "" : status);
  // };


// ✅ LOAD DATA ON REFRESH based on URL or localStorage
useEffect(() => {
  let lastPathSegment = currentPath.split("/").filter(Boolean).pop() || "";
  let parentMenu = "";
  let submenu = "";

  if (menuListData?.data) {
    
    // 0. Check if the previously selected item from localStorage was an external URL
    const savedSubmenu = localStorage.getItem("activeSubmenu");
    let isSavedExternal = false;
    let savedParentMenu = "";
    
    if (savedSubmenu) {
      menuListData.data.forEach((menu) => {
        if (menu.children) {
          menu.children.forEach((item) => {
            if (item.title === savedSubmenu) {
              savedParentMenu = menu.title;
              if (item.is_externalUrl || (item.url && item.url.startsWith("http"))) {
                isSavedExternal = true;
              }
            }
            if (item.children) {
              item.children.forEach((subItem) => {
                if (subItem.title === savedSubmenu) {
                  savedParentMenu = menu.title;
                  if (subItem.is_externalUrl || (subItem.to && subItem.to.startsWith("http"))) {
                    isSavedExternal = true;
                  }
                }
              });
            }
          });
        } else {
           if (menu.title === savedSubmenu) {
              savedParentMenu = menu.title;
              if (menu.is_externalUrl || (menu.to && menu.to.startsWith("http"))) {
                isSavedExternal = true;
              }
           }
        }
      });
    }

    if (isSavedExternal) {
      // If the saved item is external, we force it to remain active.
      submenu = savedSubmenu;
      parentMenu = savedParentMenu;
    } else {
      // 1. Try to find active menu from URL
      menuListData.data.forEach((menu) => {
        if (menu.children) {
          menu.children.forEach((item) => {
            const normItem = item.url ? item.url.replace(/^\/+/, "") : "";
            const normPath = currentPath.replace(/^\/+/, "");
            if (normItem && (normPath === normItem || normPath.startsWith(normItem + "/"))) {
              parentMenu = menu.title;
              submenu = item.title;
            }

            if (item.children) {
              item.children.forEach((subItem) => {
                const normSub = subItem.to ? subItem.to.replace(/^\/+/, "") : "";
                const normPathB = currentPath.replace(/^\/+/, "");
                if (normSub && (normPathB === normSub || normPathB.startsWith(normSub + "/"))) {
                  parentMenu = menu.title;
                  submenu = item.title;
                }
              });
            }
          });
        } else {
           const normMenuUrl = menu.to ? menu.to.replace(/^\/+/, "") : "";
           const normPathC = currentPath.replace(/^\/+/, "");
           if (normMenuUrl && (normPathC === normMenuUrl || normPathC.startsWith(normMenuUrl + "/"))) {
               parentMenu = menu.title;
           }
        }
      });

      // 2. If no URL match found, fallback to localStorage
      if (!submenu && !parentMenu && savedSubmenu) {
        submenu = savedSubmenu;
        parentMenu = savedParentMenu;
      }
    }

    // Always ensure the state is synced properly to the intended menu on load or route change
    if ((submenu || parentMenu) && (state.activeSubmenu !== submenu || state.active !== parentMenu)) {
      setState({
        activeSubmenu: submenu || "",
        active: parentMenu || "",
      });
      if (submenu) {
        localStorage.setItem("activeSubmenu", submenu);
      }
    }
  }
}, [menuListData, currentPath]);

  // Enhanced function to determine which menus need login details
  const shouldShareLoginDetails = (menuTitle) => {
    const menusRequiringLogin = [

      // Add more menu titles as needed
    ];

    return menusRequiringLogin.includes(menuTitle);
  };



  // Function to build URL with complete login parameters
  // const buildUrlWithLoginParams = (
  //   baseUrl,
  //   includeCompleteUserDetails = false,
  //   menuTitle = ""
  // ) => {
  //   if (!token) return baseUrl;

  //   const params = new URLSearchParams();

  //   params.append("access_token", token);

  //   // Include complete login details as a JSON string
  //   if (includeCompleteUserDetails && loginDetails) {
  //     params.append("login_details", JSON.stringify(loginDetails));
  //   } else {
  //     // Include basic user info
  //     if (name) params.append("name", name);
  //     if (email) params.append("email", email);
  //     if (userLevel) params.append("user_level", userLevel);
  //   }

  //   const paramString = params.toString();
  //   return (
  //     baseUrl + (baseUrl?.includes("?") ? `&${paramString}` : `?${paramString}`)
  //   );
  // };


  const buildUrlWithLoginParams = (
  baseUrl,
  includeCompleteUserDetails = false,
  menuTitle = ""
) => {

  /*
  if (!token) return baseUrl;

  const params = new URLSearchParams();

  params.append("access_token", token);

  if (includeCompleteUserDetails && loginDetails) {
    params.append("login_details", JSON.stringify(loginDetails));
  } else {
    if (name) params.append("name", name);
    if (email) params.append("email", email);
    if (userLevel) params.append("user_level", userLevel);
  }

  const paramString = params.toString();
  return (
    baseUrl + (baseUrl?.includes("?") ? `&${paramString}` : `?${paramString}`)
  );
  */

  return baseUrl;
};

  const buildUrlWithTokenOnly = (baseUrl) => {
    if (!token) return baseUrl;
    const separator = baseUrl?.includes("?") ? "&" : "?";
    return `${baseUrl}${separator}${token}`;
  };

  // CLOSE THE SIDE BAR ONCE CLICK THE SUBMENU
  const handleMobileSidebarClose = () => {
    if (window.innerWidth <= 1024) {
      NavMenuToggle();
    }
  };

  return (
    <>
      {
        sidebarLoading ? (
          <li className="text-center p-3">
            <div className="d-flex flex-column align-items-center">
              <div className="spinner-border spinner-border-sm mb-2" role="status" />
              <span>Loading menu...</span>
            </div>
          </li>
        ) : (
          menuListData?.data?.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              return (
                <li
                  className={` ${state.active === data.title ? "mm-active" : ""}`}
                  key={index}
                >
                  {data.children && data.children.length > 0 ? (
                    <>
                      <Link
                        to={"#"}
                        className="has-arrow"
                        onClick={() => {
                          handleMenuActive(data.title);
                          //  handleMobileSidebarClose();
                        }}
                      >
                        <div className="d-flex gap-1">
                          <div className="me-1">
                            {data?.icon && <i className={data.icon}></i>}
                          </div>


                          <div className="nav-text txt-wrapper">
                            {data.title}
                            {data.update && data.update.length > 0 ? (
                              <span className="badge badge-xs badge-danger ms-2">
                                {data.update}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>

                      </Link>
                      <Collapse in={state.active === data.title ? true : false}>
                        <ul
                          className={`${menuClass === "mm-collapse" ? "mm-show" : ""
                            }`}
                        >
                          {data.children &&
                            data.children.map((item, index) => {

                              let url = item.url;

                              /* if (data.title === "DIGI ACCRED MANAGEMENT") {
                                 url = buildUrlWithTokenOnly(url);
                               } else */
                              if (item?.is_externalUrl) {
                                url = buildUrlWithLoginParams(url, true);
                              }

                              return (
                                <li
                                  key={index}
                                  className={`${state.activeSubmenu === item.title
                                    ? "mm-active"
                                    : ""
                                    }`}
                                >
                                  {item.children && item.children.length > 0 ? (
                                    <>
                                      <Link
                                        to={url}
                                        className={item.hasMenu ? "has-arrow" : ""}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleSubmenuActive(item.title);
                                        }}
                                      >
                                        {item.title}
                                      </Link>
                                      <Collapse
                                        in={
                                          state.activeSubmenu === item.title
                                            ? true
                                            : false
                                        }
                                      >
                                        <ul
                                          className={`${menuClass === "mm-collapse"
                                            ? "mm-show"
                                            : ""
                                            }`}
                                        >
                                          {item.children &&
                                            item.children.map(
                                              (subItem, subIndex) => {
                                                let subUrl = subItem.to;

                                                if (
                                                  shouldShareLoginDetails(
                                                    data.title
                                                  )
                                                ) {
                                                  subUrl = buildUrlWithLoginParams(
                                                    subUrl,
                                                    true
                                                  ); // Include complete user details
                                                }

                                                return (
                                                  <li key={subIndex}>
                                                    <Link
                                                      className={`${path === subItem.to
                                                        ? "mm-active"
                                                        : ""
                                                        }`}
                                                      to={subUrl}
                                                      onClick={handleMobileSidebarClose}
                                                    >
                                                      {subItem.title}
                                                    </Link>
                                                  </li>
                                                );
                                              }
                                            )}
                                        </ul>
                                      </Collapse>
                                    </>
                                  ) : (
                                    <Link 
                                      className={`${state.activeSubmenu === item.title ? "mm-active" : ""}`} 
                                      to={url}
                                      onClick={() => {
                                        handleSubmenuActive(item.title,data.title);
                                        handleMobileSidebarClose(); // ✅ FIXED
                                      }}>
                                      {item.title}
                                    </Link>
                                  )}
                                </li>
                              );
                            })}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    // For direct menu links (no submenu)
                    <Link
                      to={
                        shouldShareLoginDetails(data.title)
                          ? buildUrlWithLoginParams(data.url || data.to, true)
                          : (data.url || data.to)
                      }
                      onClick={handleMobileSidebarClose}
                    >
                      {data?.icon && <i className={data.icon}></i>}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  )}
                </li>
              );
            }
          })
        )
      }

    </>
  );
};

export default AdminSidebar;
